<template>
  <div class="rs-listing__filters">
    <div class="rs-listing__filters__top">
      <div class="rs-listing__filters__top__filter">
        <button v-on:click="toggleExpansion">
          <svg
            v-bind:class="isExpanded && 'rs-listing__rotate180'"
            width="11.064"
            height="8.424"
            viewBox="0 0 11.064 8.424"
          >
            <path
              d="M7.584-3.288,1.728-8.808l5.856-5.544h2.568L4.272-8.808l5.88,5.52Z"
              transform="translate(14.352 10.152) rotate(-90)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Filter']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__category">
        <button v-on:click="toggleExpansion">
          <svg width="20" height="16.25" viewBox="0 0 20 16.25">
            <path
              d="M3.125-15.625H.625A.625.625,0,0,0,0-15v2.5a.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75-12.5V-15A.625.625,0,0,0,3.125-15.625Zm0,6.25H.625A.625.625,0,0,0,0-8.75v2.5a.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75-6.25v-2.5A.625.625,0,0,0,3.125-9.375Zm0,6.25H.625A.625.625,0,0,0,0-2.5V0A.625.625,0,0,0,.625.625h2.5A.625.625,0,0,0,3.75,0V-2.5A.625.625,0,0,0,3.125-3.125Zm16.25-5.312H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-7.187v-.625A.625.625,0,0,0,19.375-8.437Zm0,6.25H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-.937v-.625A.625.625,0,0,0,19.375-2.187Zm0-12.5H6.875a.625.625,0,0,0-.625.625v.625a.625.625,0,0,0,.625.625h12.5A.625.625,0,0,0,20-13.437v-.625A.625.625,0,0,0,19.375-14.687Z"
              transform="translate(0 15.625)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Category']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__search">
        <button v-on:click="toggleExpansion">
          <svg width="20.001" height="20.001" viewBox="0 0 20.001 20.001">
            <path
              d="M19.863.816,15.121-3.926a.464.464,0,0,0-.332-.137h-.516A8.1,8.1,0,0,0,16.25-9.375,8.124,8.124,0,0,0,8.125-17.5,8.124,8.124,0,0,0,0-9.375,8.124,8.124,0,0,0,8.125-1.25a8.1,8.1,0,0,0,5.312-1.977v.516a.48.48,0,0,0,.137.332l4.742,4.742a.469.469,0,0,0,.664,0l.883-.883A.469.469,0,0,0,19.863.816ZM8.125-3.125a6.248,6.248,0,0,1-6.25-6.25,6.248,6.248,0,0,1,6.25-6.25,6.248,6.248,0,0,1,6.25,6.25A6.248,6.248,0,0,1,8.125-3.125Z"
              transform="translate(0 17.5)"
              fill="#652981"
            />
          </svg>

          <span v-html="fetchedStrings['Search']" />
        </button>
      </div>

      <div class="rs-listing__filters__top__reset">
        <transition name="rs-listing-reset">
          <button v-if="isFiltering" v-on:click="onResetButtonClick">
            <span v-html="fetchedStrings['Reset']" />
          </button>
        </transition>
      </div>
    </div>

    <div class="rs-listing__filters__divide">
      <hr />
    </div>

    <transition name="rs-listing__filters__expandable__transition">
      <div class="rs-listing__filters__expandable" v-if="isExpanded">
        <div class="rs-listing__filters__expandable__void"></div>
        <div class="rs-listing__filters__expandable__list">
          <label v-for="category in fetchedCategories" :key="category.slug">
            <input
              type="checkbox"
              v-model="localSelectedCategories"
              :value="category.slug"
              @change="onSelectedFiltersChange"
            />
            <span v-html="category.name" />
            <!-- <span class="rs-listing__filters__expandable__list__count"
              >({{ category.count }})</span
            > -->
          </label>
        </div>
        <div class="rs-listing__filters__expandable__search">
          <input
            type="text"
            v-model="localSearchKeywords"
            :placeholder="fetchedStrings['Keywords']"
            v-on:keyup.enter="onSearchButtonClick"
          />
          <button v-on:click="onSearchButtonClick">
            <svg width="20.001" height="20.001" viewBox="0 0 20.001 20.001">
              <path
                d="M19.863.816,15.121-3.926a.464.464,0,0,0-.332-.137h-.516A8.1,8.1,0,0,0,16.25-9.375,8.124,8.124,0,0,0,8.125-17.5,8.124,8.124,0,0,0,0-9.375,8.124,8.124,0,0,0,8.125-1.25a8.1,8.1,0,0,0,5.312-1.977v.516a.48.48,0,0,0,.137.332l4.742,4.742a.469.469,0,0,0,.664,0l.883-.883A.469.469,0,0,0,19.863.816ZM8.125-3.125a6.248,6.248,0,0,1-6.25-6.25,6.248,6.248,0,0,1,6.25-6.25,6.248,6.248,0,0,1,6.25,6.25A6.248,6.248,0,0,1,8.125-3.125Z"
                transform="translate(0 17.5)"
                fill="#652981"
              />
            </svg>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    fetchedCategories: Array,
    selectedCategories: Array,
    searchKeywords: String,
    fetchedStrings: Object,
  },
  data() {
    return {
      isExpanded: false,
      localSelectedCategories: null,
      localSearchKeywords: null,
    };
  },
  computed: {
    isFiltering() {
      if (this.localSelectedCategories && this.localSelectedCategories.length)
        return true;
      if (this.localSearchKeywords && this.localSearchKeywords.length)
        return true;
      return false;
    },
  },
  watch: {
    selectedCategories(value) {
      this.localSelectedCategories = value;
      this.expandIfFiltering();
    },
    searchKeywords(value) {
      this.localSearchKeywords = value;
      this.expandIfFiltering();
    },
  },
  mounted() {
    this.localSelectedCategories = this.selectedCategories;
    this.localSearchKeywords = this.searchKeywords;
  },
  methods: {
    expandIfFiltering() {
      if (this.isFiltering) this.isExpanded = true;
    },
    onSelectedFiltersChange(event) {
      this.$emit("selected-filters-change", {
        selectedCategories: this.localSelectedCategories,
      });
    },
    onSearchButtonClick() {
      this.$emit("search-keywords-change", this.localSearchKeywords);
    },
    onResetButtonClick() {
      this.localSelectedCategories = [];
      this.localSearchKeywords = "";
      this.onSelectedFiltersChange();
      this.onSearchButtonClick();
      this.isExpanded = false;
    },
    toggleExpansion() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
